export const PULL_DATA_FROM_BPM = 'systemSettings/applications@PULL_DATA_FROM_BPM';
export const PULL_DATA_ALL_MIDDLEWARE = 'systemSettings/applications@PULL_DATA_ALL_MIDDLEWARE';
export const SET_PULLED_DATA_FROM_BPM = 'systemSettings/applications@SET_PULLED_DATA_FROM_BPM';
export const SET_PULLED_ALL_MIDDLEWARE = 'systemSettings/applications@SET_PULLED_ALL_MIDDLEWARE';
export const pullDataFromBPM = () => ({ type: PULL_DATA_FROM_BPM });
export const pullDataAllMiddleware = () => ({ type: PULL_DATA_ALL_MIDDLEWARE });
export const setPulledDataFromBPM = success => ({ type: SET_PULLED_DATA_FROM_BPM, success });
export const setPulledAllMiddleware = success => ({ type: SET_PULLED_ALL_MIDDLEWARE, success });

export const PING_MIDDLEWARE_APPLICATION = 'systemSettings/applications@PING_MIDDLEWARE_APPLICATION';
export const SET_PING_MIDDLEWARE_APPLICATION = 'systemSettings/applications@SET_PING_MIDDLEWARE_APPLICATION';
export const pingMiddlewareApplication = middleware => ({ type: PING_MIDDLEWARE_APPLICATION, middleware });
export const setPingMiddlewareApplication = payload => ({ type: SET_PING_MIDDLEWARE_APPLICATION, payload });

export const PING_IFLOW_BASED_APPLICATION = 'systemSettings/applications@PING_IFLOW_BASED_APPLICATION';
export const SET_PING_IFLOW_BASED_APPLICATION = 'systemSettings/applications@SET_PING_IFLOW_BASED_APPLICATION';
export const pingIFlowBasedApplication = payload => ({ type: PING_IFLOW_BASED_APPLICATION, payload });
export const setPingIFlowBasedApplication = payload => ({ type: SET_PING_IFLOW_BASED_APPLICATION, payload });
